import 'bootstrap/dist/css/bootstrap.min.css';
import React from 'react';
import ReactDOM from 'react-dom';
import Immutable from 'immutable';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware, compose } from 'redux';
import reduxThunk from 'redux-thunk';
import Amplify from 'aws-amplify';
import WebFont from 'webfontloader';

import registerServiceWorker from './registerServiceWorker';
import core from './modules/core';
import auth from './modules/auth';
import reducers from './rootReducer';
import config from './config';

// Development only axios helpers!
import axios from 'axios';
window.axios = axios;

// Redux devtools
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const initialState = Immutable.Map();
const store = createStore(
  reducers,
  initialState,
  composeEnhancers(applyMiddleware(reduxThunk))
);

Amplify.configure({
  Auth: {
    mandatorySignIn: true,
    region: config.cognito.REGION,
    userPoolId: config.cognito.USER_POOL_ID,
    identityPoolId: config.cognito.IDENTITY_POOL_ID,
    userPoolWebClientId: config.cognito.APP_CLIENT_ID
  },
  API: {
    endpoints: [
      {
        name: 'ptapp',
        endpoint: config.apiGateway.URL,
        region: config.apiGateway.REGION
      }
    ]
  }
});

WebFont.load({
  google: {
    families: ['Maven Pro', 'Open Sans']
  }
});

ReactDOM.render(
  <Provider store={store}>
    <BrowserRouter>
      <Switch>
        <Route path="/" exact component={core.components.Landing} />
        <Route path="/auth" component={auth.components.AuthRoutes} />
        <Route component={core.components.App} />
      </Switch>
    </BrowserRouter>
  </Provider>,
  document.querySelector('#root')
);

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js